import React from "react";
import Violation from "license/LicenseState/Violation";
const LicenseState = ({ violations, version = void 0 }) => {
  const versionMissingViolation = "version_missing";
  const violationsMap = {
    violated: {
      severity: "warning",
      text: "Violations detected"
    },
    expired: {
      severity: "warning",
      text: "License has expired!"
    },
    cluster_not_covered: {
      severity: "info",
      text: "This cluster is not covered by the license."
    },
    nodes_exceeded: {
      severity: "info",
      text: { 1: "Too many nodes in cluster!" }
    },
    traffic_exceeded: {
      severity: "info",
      text: {
        2: "Daily traffic limit has been exceeded too many times.",
        3: "License volume has been used.",
        4: "Daily traffic limit has been exceeded too many times."
      }
    },
    remote_checks_failed: {
      severity: "info",
      text: { 2: "Remote checks have failed too many times.", 4: "Remote checks have failed too many times." }
    },
    version_missing: {
      severity: "info",
      text: "Unknown license version, cannot display details."
    }
  };
  const genericViolations = ["violated", "expired", "cluster_not_covered"];
  const versionDependantViolations = {
    1: ["nodes_exceeded"],
    2: ["traffic_exceeded", "remote_checks_failed"],
    3: ["traffic_exceeded"],
    4: ["traffic_exceeded", "remote_checks_failed"]
  };
  const violatedViolations = () => {
    const violatedGenericViolations = genericViolations.filter((violationName) => violations[violationName] === true);
    if (!version) {
      return [...violatedGenericViolations, versionMissingViolation];
    }
    const violatedVersionDependantViolations = versionDependantViolations[version].filter(
      (violationName) => violations[violationName] === true
    );
    return [...violatedGenericViolations, ...violatedVersionDependantViolations];
  };
  if (violatedViolations().length < 1) {
    return /* @__PURE__ */ React.createElement(Violation, { text: "No problems detected." });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, violatedViolations().map((violation) => {
    var _a;
    const violationText = (_a = violationsMap[violation]) == null ? void 0 : _a.text;
    if (typeof violationText === "string") {
      return /* @__PURE__ */ React.createElement(Violation, { key: violation, text: violationText, severity: violationsMap[violation].severity });
    }
    return /* @__PURE__ */ React.createElement(Violation, { key: violation, text: violationText[version], severity: violationsMap[violation].severity });
  }));
};
export default LicenseState;
